module.exports = __webpack_public_path__ + "static/media/mc20-logo.b7b1166d.png";